export * from './useProductDetailsCarouselItems';
